<template>
  <section>
    <h3>Tablero</h3>
    <v-card>
      <v-card-text>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
  export default {
    components: {
    },
    methods: {
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/admin/Dashboard.vue